import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { useQueryClient } from '@tanstack/react-query';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import TableWidgetsLayout from './TableWidgetsLayout.component';
import { useFolderStatistics } from '../../../../hooks/useGetFolderStatictis';
import { useKnowledgeContext } from '../../../../providers/Knowledge/Knowledge.provider';

interface TableWidgetsProps {
    className?: string;
}
const TableWidgets: FC<TableWidgetsProps> = ({ className }) => {
    const queryClient = useQueryClient(); // Access the query client
    const location = useLocation();

    const userInfo: IAuthMeV2OutputDto | undefined = queryClient.getQueryData(['userInfo']);
    const currentOrganization = userInfo?.currentOrganization;

    const { statictics, isLoadingDocuments } = useKnowledgeContext();

    const ids = location.pathname
        .replace(/^\/knowledge\//, '') // Quitar el prefijo /knowledge/
        .split('/') // Dividir por cada nivel
        .filter(Boolean);
    const { data, isLoading, isFetching } = useFolderStatistics(ids[0] !== currentOrganization ? ids[0] : undefined);

    // Simulated data, replace with actual data from context or props
    return isLoading || isLoadingDocuments || isFetching ? (
        <div
            className={twMerge(
                'h-9 justify-start items-center px-4 py-2 bg-[#edf0f2] dark:bg-[#202222] rounded w-full animate-pulse',
                className,
            )}
        />
    ) : (
        <TableWidgetsLayout
            folderCount={statictics?.folders || 0}
            fileCount={data?.total_documents}
            activeCount={data?.by_active?.['active'] || 0}
            inactiveCount={data?.by_active?.['inactive'] || 0}
            className={className}
        />
    );
};

export default TableWidgets;
